/* Atelier64 — animações de entrada (respeita "reduzir movimento") */
(function () {
  var root = document.documentElement;
  root.classList.add('a64-js');
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Divide o texto do manifesto em palavras para acender uma a uma
  document.querySelectorAll('[data-a64-words]').forEach(function (el) {
    if (el.dataset.a64Split) return;
    el.dataset.a64Split = '1';
    var words = el.textContent.trim().split(/\s+/);
    el.textContent = '';
    words.forEach(function (w, i) {
      var s = document.createElement('span');
      s.className = 'a64-word';
      s.style.setProperty('--i', i);
      s.textContent = w + ' ';
      el.appendChild(s);
    });
  });

  // Altura do hero = tela visível abaixo do cabeçalho
  var hero = document.querySelector('.a64-hero');
  function fitHero() { if (hero) root.style.setProperty('--a64-top', Math.max(0, Math.round(hero.getBoundingClientRect().top + window.scrollY)) + 'px'); }
  fitHero(); window.addEventListener('resize', fitHero); window.addEventListener('load', fitHero);

  var targets = document.querySelectorAll('[data-a64-reveal], [data-a64-words], [data-a64-hero]');
  if (reduce || !('IntersectionObserver' in window)) {
    targets.forEach(function (el) { el.classList.add('is-in'); });
    return;
  }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
  targets.forEach(function (el) { io.observe(el); });

  // Leve parallax na imagem do hero
  var heroImg = document.querySelector('.a64-hero__media img');
  if (heroImg) {
    var ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        var y = Math.min(window.scrollY, window.innerHeight);
        heroImg.style.transform = 'translate3d(0,' + (y * 0.18) + 'px,0) scale(1.06)';
        ticking = false;
      });
    }, { passive: true });
  }
})();

/* ===================== Interações ===================== */
(function () {
  var doc = document, root = doc.documentElement;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var finePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  /* ---- 1. Abertura "partida a frio": painel apagado → botão START → partida (som) → logo acende → tela abre ----
     Os navegadores só tocam som depois de um toque/clique; o botão de partida é esse toque.
     Sem toque em 10 s, a abertura segue sozinha, sem som. Toca na 1ª visita, em todo F5 e ao chegar de fora. */
  var logoTpl = doc.getElementById('a64-intro-logo');
  if (logoTpl && root.classList.contains('a64-intro-pre') && !reduce) {
    var pre = doc.createElement('div');
    pre.className = 'a64-intro a64-intro--v3 a64-intro--cs';
    pre.setAttribute('role', 'dialog'); pre.setAttribute('aria-label', 'Abertura Atelier64');
    pre.innerHTML =
      '<span class="a64-intro__half a64-intro__half--t"></span><span class="a64-intro__half a64-intro__half--b"></span>' +
      '<div class="a64-intro__mark">' + logoTpl.innerHTML + '<span class="a64-intro__dash"></span></div>' +
      '<span class="a64-intro__line"></span>' +
      '<div class="a64-intro__ign">' +
        '<button type="button" class="a64-intro__start" aria-label="Dar a partida (com som)">' +
          '<svg viewBox="0 0 100 100" aria-hidden="true"><circle class="a64-intro__ring" cx="50" cy="50" r="46"/><circle class="a64-intro__timer" cx="50" cy="50" r="46"/></svg>' +
          '<span class="a64-intro__start-t">START</span><span class="a64-intro__start-s">ENGINE</span></button>' +
        '<p class="a64-intro__hint a64-mono"><span>Toque para dar a partida</span><button type="button" class="a64-intro__mute">entrar sem som</button></p>' +
      '</div>' +
      '<div class="a64-intro__foot a64-mono"><span>Atelier64</span><span class="a64-intro__num">000</span><span>Herança das pistas</span></div>';
    doc.body.appendChild(pre);
    root.classList.add('a64-intro-on');
    // abrir/recarregar o site sempre começa no topo (a loja), não onde a pessoa parou
    var toTop = function () { if (!location.hash) { window.scrollTo(0, 0); if (window.a64Lenis) window.a64Lenis.scrollTo(0, { immediate: true }); } };
    toTop(); window.addEventListener('load', toTop, { once: true }); setTimeout(toTop, 300);
    var num = pre.querySelector('.a64-intro__num'), startBtn = pre.querySelector('.a64-intro__start');
    pre.querySelectorAll('.a64-intro__mark path').forEach(function (p) {
      try { p.style.setProperty('--len', Math.ceil(p.getTotalLength())); } catch (e) {}
    });
    // som: Web Audio (arquivo já baixado e decodificado antes do toque = partida instantânea e confiável);
    // se ainda não estiver pronto no toque, usa o <audio> comum como reserva.
    var sndUrl = logoTpl.getAttribute('data-sound'), au = null, actx = null, abuf = null;
    if (sndUrl) {
      au = new Audio(sndUrl); au.preload = 'auto'; au.volume = .9; try { au.load(); } catch (e) {}
      try {
        var AC = window.AudioContext || window.webkitAudioContext;
        if (AC && window.fetch) {
          actx = new AC();
          fetch(sndUrl).then(function (r) { return r.arrayBuffer(); }).then(function (ab) {
            return new Promise(function (ok, no) { var p = actx.decodeAudioData(ab, ok, no); if (p && p.then) p.then(ok, no); });
          }).then(function (b) { abuf = b; }).catch(function () {});
        }
      } catch (e) { actx = null; }
    }
    var touchDev = window.matchMedia('(hover: none), (pointer: coarse)').matches;
    function playRoar() {
      // iPhone: o modo silencioso cala a Web Audio; o <audio> comum toca como mídia
      try { if (navigator.audioSession) navigator.audioSession.type = 'playback'; } catch (e) {}
      if (touchDev && au) {
        try { au.currentTime = 0; } catch (e) {}
        au.muted = false; au.volume = 1;
        var hp = au.play();
        if (hp && hp.catch) hp.catch(function () { tryWebAudio(); });
        return;
      }
      tryWebAudio();
    }
    function tryWebAudio() {
      try {
        if (actx && abuf) {
          if (actx.state !== 'running') actx.resume();
          var src = actx.createBufferSource(), g = actx.createGain();
          src.buffer = abuf; g.gain.value = .9; src.connect(g); g.connect(actx.destination); src.start(0);
          return;
        }
      } catch (e) {}
      if (au) { try { au.currentTime = 0; } catch (e) {} var p = au.play(); p && p.catch && p.catch(function () {}); }
    }
    var started = false, at = function (ms, fn) { setTimeout(fn, ms); };
    // conta-giros: 000 → 100 com "tranco" na partida
    function rev(t0) {
      (function tick(now) {
        var t = now - t0, v;
        if (t < 450) v = 4 + Math.random() * 8;                    // motor de arranque
        else if (t < 950) v = 12 + (t - 450) / 500 * 88;            // pega e sobe
        else v = 100;
        num.textContent = String(Math.round(v)).padStart(3, '0');
        if (t < 1000) requestAnimationFrame(tick);
      })(t0);
    }
    function ignite(withSound) {
      if (started) return; started = true;
      clearTimeout(autoT);
      if (withSound) playRoar();
      pre.classList.add('is-press');
      rev(performance.now());
      at(60, function () { pre.classList.add('is-crank'); });
      at(450, function () { pre.classList.add('is-draw', 'is-ignite'); });
      at(700, function () { pre.classList.add('is-fill'); });
      at(1500, function () { pre.classList.add('is-dash'); });
      at(2150, function () { pre.classList.add('is-fade'); });
      at(2450, function () { pre.classList.add('is-line'); });
      at(3000, function () { pre.classList.add('is-out'); root.classList.remove('a64-intro-on'); root.classList.remove('a64-intro-pre'); });
      at(4300, function () { pre.remove(); });
    }
    startBtn.addEventListener('click', function () { ignite(true); });
    pre.querySelector('.a64-intro__mute').addEventListener('click', function () { ignite(false); });
    doc.addEventListener('keydown', function k(e) { if (started || !pre.isConnected) { doc.removeEventListener('keydown', k); return; } if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); ignite(true); } else if (e.key === 'Escape') ignite(false); doc.removeEventListener('keydown', k); });
    requestAnimationFrame(function () { requestAnimationFrame(function () { pre.classList.add('is-ready'); try { startBtn.focus({ preventScroll: true }); } catch (e) {} }); });
    var autoT = setTimeout(function () { ignite(false); }, 10000);
  } else {
    root.classList.remove('a64-intro-pre');
  }

  /* ---- 2. Cursor personalizado ---- */
  if (finePointer && !reduce) {
    var cur = doc.createElement('div');
    cur.className = 'a64-cursor';
    cur.innerHTML = '<span class="a64-cursor__label"></span><i class="a64-cursor__dot"></i><i class="a64-cursor__ring"></i>';
    doc.body.appendChild(cur);
    root.classList.add('a64-has-cursor');
    var label = cur.firstChild, raf = 0, mx = -100, my = -100;
    // segue o mouse exatamente (sem atraso, sem rastro)
    window.addEventListener('mousemove', function (e) {
      mx = e.clientX; my = e.clientY;
      if (!raf) raf = requestAnimationFrame(function () { raf = 0; cur.style.transform = 'translate3d(' + mx + 'px,' + my + 'px,0)'; });
    }, { passive: true });
    doc.addEventListener('mouseover', function (e) {
      var tf = e.target.closest('input:not([type=submit]):not([type=button]), textarea, select');
      cur.classList.toggle('is-text', !!tf);
      var t = e.target.closest('[data-cursor], a, button, input, select, textarea, label, summary');
      cur.classList.toggle('is-link', !!t && !t.hasAttribute('data-cursor'));
      var txt = t && t.getAttribute('data-cursor');
      cur.classList.toggle('is-label', !!txt);
      label.textContent = txt || '';
      if (txt) cur.setAttribute('data-label', txt); else cur.removeAttribute('data-label');
    });
    doc.addEventListener('mousedown', function () { cur.classList.add('is-down'); });
    doc.addEventListener('mouseup', function () { cur.classList.remove('is-down'); });
    doc.addEventListener('mouseleave', function () { cur.classList.add('is-hidden'); });
    doc.addEventListener('mouseenter', function () { cur.classList.remove('is-hidden'); });
  }

  /* ---- 3. Botões magnéticos ---- */
  if (finePointer && !reduce) {
    doc.querySelectorAll('[data-magnetic]').forEach(function (el) {
      el.addEventListener('mousemove', function (e) {
        var r = el.getBoundingClientRect();
        var x = (e.clientX - r.left - r.width / 2) * 0.28, y = (e.clientY - r.top - r.height / 2) * 0.4;
        el.style.transform = 'translate(' + x + 'px,' + y + 'px)';
      });
      el.addEventListener('mouseleave', function () { el.style.transform = ''; });
    });
  }

  /* ---- 4. Hero reage ao mouse ---- */
  var hero = doc.querySelector('.a64-hero');
  if (hero && finePointer && !reduce) {
    var media = hero.querySelector('.a64-hero__media'), title = hero.querySelector('.a64-hero__title');
    hero.addEventListener('mousemove', function (e) {
      var r = hero.getBoundingClientRect();
      var dx = (e.clientX - r.left) / r.width - 0.5, dy = (e.clientY - r.top) / r.height - 0.5;
      if (media) media.style.transform = 'translate3d(' + (-dx * 18) + 'px,' + (-dy * 12) + 'px,0)';
      if (title) title.style.transform = 'translate3d(' + (dx * 10) + 'px,' + (dy * 6) + 'px,0)';
      hero.style.setProperty('--mx', (e.clientX - r.left) + 'px');
      hero.style.setProperty('--my', (e.clientY - r.top) + 'px');
    });
    hero.addEventListener('mouseleave', function () { if (media) media.style.transform = ''; if (title) title.style.transform = ''; });
  }

  /* ---- 5. Galeria arrastável (mouse, toque e roda) ---- */
  doc.querySelectorAll('[data-a64-drag]').forEach(function (vp) {
    var track = vp.querySelector('.a64-drag__track');
    var section = vp.closest('.a64-drag');
    var prog = section && section.querySelector('.a64-drag__progress i');
    var count = section && section.querySelector('.a64-drag__count');
    var items = track.children;
    var x = 0, target = 0, down = false, startX = 0, startT = 0, moved = 0, vel = 0, lastX = 0;
    function max() { return Math.max(0, track.scrollWidth - vp.clientWidth); }
    function clamp(v) { return Math.max(-max(), Math.min(0, v)); }
    vp.addEventListener('pointerdown', function (e) {
      down = true; moved = 0; startX = e.clientX; startT = target; lastX = e.clientX; vel = 0;
      vp.classList.add('is-dragging');
    });
    window.addEventListener('pointermove', function (e) {
      if (!down) return;
      var d = e.clientX - startX; moved = Math.max(moved, Math.abs(d));
      vel = e.clientX - lastX; lastX = e.clientX;
      target = clamp(startT + d * 1.15);
    });
    window.addEventListener('pointerup', function () {
      if (!down) return; down = false; vp.classList.remove('is-dragging');
      target = clamp(target + Math.max(-420, Math.min(420, vel * 8)));
    });
    vp.addEventListener('click', function (e) { if (moved > 6) { e.preventDefault(); e.stopPropagation(); } }, true);
    vp.addEventListener('wheel', function (e) {
      if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) { target = clamp(target - e.deltaX); e.preventDefault(); }
    }, { passive: false });
    (function loop() {
      x += (target - x) * (reduce ? 1 : 0.12);
      track.style.transform = 'translate3d(' + x.toFixed(2) + 'px,0,0)';
      var m = max(), k = m ? -x / m : 0;
      if (prog) prog.style.transform = 'scaleX(' + Math.max(0.04, k) + ')';
      if (count && items.length) count.textContent = String(Math.min(items.length, Math.round(k * (items.length - 1)) + 1)).padStart(2, '0');
      // leve inclinação conforme a velocidade
      var skew = Math.max(-6, Math.min(6, (target - x) * 0.02));
      for (var i = 0; i < items.length; i++) items[i].style.transform = 'skewX(' + (reduce ? 0 : skew) + 'deg)';
      requestAnimationFrame(loop);
    })();
    window.addEventListener('resize', function () { target = clamp(target); });
  });

  /* ---- 6. Troca de cor na vitrine ---- */
  doc.querySelectorAll('[data-a64-showcase]').forEach(function (sc) {
    var btns = sc.querySelectorAll('.a64-switch__btn'), medias = sc.querySelectorAll('.a64-showcase__media[data-color]');
    btns.forEach(function (b) {
      b.addEventListener('click', function () {
        var c = b.getAttribute('data-color');
        btns.forEach(function (o) { var on = o === b; o.classList.toggle('is-active', on); o.setAttribute('aria-selected', on); });
        medias.forEach(function (m) { m.classList.toggle('is-active', m.getAttribute('data-color') === c); });
      });
    });
  });
})();

/* ===================== Lookbook, contadores, rolagem suave ===================== */
(function () {
  var doc = document, root = doc.documentElement;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- Altura do cabeçalho (para o hero passar por baixo da cápsula) ---- */
  var headerSec = doc.getElementById('shopify-section-header');
  function setHeaderH() { if (headerSec) root.style.setProperty('--a64-header-h', headerSec.offsetHeight + 'px'); }
  setHeaderH(); window.addEventListener('resize', setHeaderH); window.addEventListener('load', setHeaderH);
  if (doc.querySelector('.a64-hero')) root.classList.add('a64-home');
  window.addEventListener('scroll', function () { root.classList.toggle('a64-scrolled', window.scrollY > 40); }, { passive: true });

  /* ---- Lookbook ---- */
  doc.querySelectorAll('[data-a64-lookbook]').forEach(function (hero) {
    var slides = hero.querySelectorAll('.a64-hero__slide');
    var items = hero.querySelectorAll('.a64-lookbook__item');
    var pauseBtn = hero.querySelector('[data-pause]');
    if (slides.length < 2) return;
    var interval = (parseFloat(hero.dataset.interval) || 6) * 1000;
    var i = 0, paused = reduce, start = performance.now(), elapsed = 0;
    // Transição em camadas: a cena nova sempre entra POR CIMA (0 → 1, saindo do desfoque).
    // Se voltar para a cena que ainda está visível por baixo, a de cima faz o caminho inverso (1 → 0),
    // então a transição é igual em qualquer direção e velocidade.
    var Z = 2, top = slides[0], under = null, overTop = false, cleanT = 0;
    slides.forEach(function (s, k) { s.style.opacity = k === 0 ? '1' : '0'; s.style.zIndex = k === 0 ? '2' : '0'; if (k === 0) s.classList.add('is-shown'); });
    function settle(keep) {
      clearTimeout(cleanT);
      cleanT = setTimeout(function () {
        slides.forEach(function (s) {
          if (s === keep) return;
          s.style.setProperty('transition', 'none', 'important'); s.style.opacity = '0'; s.style.filter = 'blur(8px)'; s.style.zIndex = '0'; s.classList.remove('is-shown');
          void s.offsetWidth; s.style.removeProperty('transition');
        });
        top = keep; under = null; overTop = false;
      }, 1750);
    }
    function go(n) {
      n = (n + slides.length) % slides.length;
      var target = slides[n];
      if (n === i) { elapsed = 0; start = performance.now(); return; }
      i = n;
      if (target === under && !overTop) {
        // volta rápida: a cena de cima desvanece e revela a de baixo (caminho inverso)
        var leaving = top;
        leaving.style.opacity = '0'; leaving.style.filter = 'blur(8px)';
        top = target; under = leaving; overTop = true;
        target.classList.add('is-shown');
        settle(target);
      } else if (target === under && overTop) {
        // ida e volta de novo: a cena que estava saindo por cima volta a aparecer
        target.style.opacity = '1'; target.style.filter = 'blur(0px)';
        under = top; top = target; overTop = false;
        settle(target);
      } else {
        target.style.setProperty('transition', 'none', 'important'); target.style.opacity = '0'; target.style.filter = 'blur(8px)';
        target.style.zIndex = String(++Z); target.classList.add('is-shown');
        void target.offsetWidth;
        target.style.removeProperty('transition'); target.style.opacity = '1'; target.style.filter = 'blur(0px)';
        under = top; top = target; overTop = false;
        settle(target);
      }
      slides.forEach(function (s, k) { s.classList.toggle('is-active', k === i); });
      var cta = hero.querySelector('[data-hero-cta]'); if (cta) { var l = slides[i].getAttribute('data-link'); cta.href = l || cta.getAttribute('data-default'); }
      items.forEach(function (b, k) { b.classList.toggle('is-active', k === i); if (k === i) b.setAttribute('aria-current', 'true'); else b.removeAttribute('aria-current'); var bar = b.querySelector('b'); if (bar) bar.style.transform = 'scaleX(0)'; });
      elapsed = 0; start = performance.now();
    }
    // passar o mouse mostra a cena (com uma pequena pausa, para não trocar ao atravessar a lista);
    // clicar leva ao destino da cena na mesma janela (é um link normal)
    var hoverT = 0;
    items.forEach(function (b) {
      b.addEventListener('mouseenter', function () {
        if (!window.matchMedia('(hover: hover)').matches) return;
        clearTimeout(hoverT); hoverT = setTimeout(function () { go(parseInt(b.dataset.go, 10)); }, 220);
      });
      b.addEventListener('mouseleave', function () { clearTimeout(hoverT); });
      b.addEventListener('focus', function () { go(parseInt(b.dataset.go, 10)); });
    });
    function setPaused(p) {
      paused = p; if (pauseBtn) { pauseBtn.textContent = p ? 'PLAY' : 'PAUSAR'; pauseBtn.setAttribute('aria-pressed', p); }
      if (!p) start = performance.now() - elapsed;
    }
    if (pauseBtn) { pauseBtn.addEventListener('click', function () { setPaused(!paused); }); if (reduce) setPaused(true); }
    (function tick(now) {
      if (!paused) {
        elapsed = now - start;
        var bar = items[i] && items[i].querySelector('b');
        if (bar) bar.style.transform = 'scaleX(' + Math.min(1, elapsed / interval) + ')';
        if (elapsed >= interval) go(i + 1);
      }
      requestAnimationFrame(tick);
    })(performance.now());
  });

  /* ---- Contadores ---- */
  var counters = doc.querySelectorAll('[data-count]');
  if (counters.length && 'IntersectionObserver' in window) {
    var cio = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return; cio.unobserve(e.target);
        var el = e.target, raw = el.dataset.count, target = parseFloat(String(raw).replace(',', '.'));
        if (isNaN(target) || reduce) return;
        var dec = (String(raw).split(/[.,]/)[1] || '').length, t0 = performance.now(), dur = 1600;
        (function step(now) {
          var k = Math.min(1, (now - t0) / dur), v = target * (1 - Math.pow(1 - k, 4));
          el.textContent = v.toFixed(dec).replace('.', ',');
          if (k < 1) requestAnimationFrame(step); else el.textContent = raw;
        })(t0);
      });
    }, { threshold: 0.6 });
    counters.forEach(function (c) { cio.observe(c); });
  }

  /* ---- Rolagem suave (Lenis) ---- */
  if (!reduce && window.Lenis && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
    var lenis = new window.Lenis({ lerp: 0.1, smoothWheel: true,
      prevent: function (node) { return !!(node.closest && node.closest('.drawer, .popover, [role="dialog"], .modal, #modal, .a64-drag__viewport, .predictive-search, .header__search-bar')); } });
    window.a64Lenis = lenis;
    (function raf(t) { lenis.raf(t); requestAnimationFrame(raf); })(performance.now());
    // pausa a rolagem suave quando o tema trava a página (menu, carrinho, popups)
    var check = function () {
      // não olha o overflow do <html>: a própria pausa do Lenis o deixa "hidden" (isso travava a rolagem para sempre)
      var locked = /lock/.test(root.className) || /lock/.test(doc.body.className) || root.classList.contains('a64-intro-on') || root.classList.contains('a64-lb-on') || getComputedStyle(doc.body).overflow === 'hidden';
      locked ? lenis.stop() : lenis.start();
    };
    new MutationObserver(check).observe(root, { attributes: true, attributeFilter: ['class', 'style'] });
    new MutationObserver(check).observe(doc.body, { attributes: true, attributeFilter: ['class', 'style'] });
    root.classList.add('a64-lenis');
  }
})();

/* ===================== Drops: imagem flutuante ===================== */
(function () {
  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
  document.querySelectorAll('[data-a64-drops]').forEach(function (sec) {
    var fl = sec.querySelector('.a64-drops__float'), img = fl && fl.querySelector('img');
    if (!fl) return;
    var x = 0, y = 0, tx = 0, ty = 0, on = false;
    sec.querySelectorAll('a[data-img]').forEach(function (a) {
      a.addEventListener('mouseenter', function () { img.src = a.dataset.img; on = true; fl.classList.add('is-on'); });
      a.addEventListener('mouseleave', function () { on = false; fl.classList.remove('is-on'); });
    });
    sec.addEventListener('mousemove', function (e) { var r = sec.getBoundingClientRect(); tx = e.clientX - r.left; ty = e.clientY - r.top; });
    (function loop() { x += (tx - x) * 0.14; y += (ty - y) * 0.14; var rot = Math.max(-8, Math.min(8, (tx - x) * 0.05));
      fl.style.transform = 'translate3d(' + x + 'px,' + y + 'px,0) translate(-50%,-50%) rotate(' + rot + 'deg)'; requestAnimationFrame(loop); })();
  });
})();

/* ===================== Faixa de foto: parallax ===================== */
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var bands = document.querySelectorAll('[data-a64-band] .a64-band__img img');
  if (!bands.length) return;
  var tick = false;
  function run() {
    bands.forEach(function (img) {
      var r = img.closest('[data-a64-band]').getBoundingClientRect(), vh = window.innerHeight;
      if (r.bottom < 0 || r.top > vh) return;
      var k = (r.top + r.height / 2 - vh / 2) / vh;
      img.style.transform = 'translate3d(0,' + (k * -12) + '%,0)';
    });
    tick = false;
  }
  window.addEventListener('scroll', function () { if (!tick) { tick = true; requestAnimationFrame(run); } }, { passive: true });
  run();
})();
